import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, Leaf } from 'lucide-react';
import { Button } from './ui/button';
import { track } from '../lib/track';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Détecter si on est sur mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const navItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Frelon Asiatique', path: '/frelon-asiatique' },
    { name: 'Contact', path: '/contact' }
  ];

  const handleCall = () => {
    track('phone_click', { location: 'header' });
    window.location.href = 'tel:0676583038';
  };

  return (
    <header className="sticky top-0 z-50 frelon-glass backdrop-blur-20 border-b border-white/20 frelon-slide-up">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo Frelon33™ Ultra-Moderne */}
          <Link to="/" className="flex items-center space-x-4 group">
            <div className="relative frelon-float">
              <img 
                src="https://customer-assets.emergentagent.com/job_frelon33-experts/artifacts/yswmny6u_logo%20principal.png"
                alt="Frelon33™ Logo" 
                className="h-16 w-auto transition-all duration-300 group-hover:scale-110 frelon-zoom-gentle"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"></div>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-black frelon33-brand tracking-tight">
                FRELON33™
              </span>
              <div className="flex items-center space-x-2">
                <Leaf className="h-3 w-3 text-green-600 animate-pulse" />
                <span className="text-sm font-medium text-green-700 frelon33-accent">
                  Expert écologique
                </span>
              </div>
            </div>
          </Link>

          {/* Navigation Desktop Moderne */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`relative font-medium text-lg transition-all duration-300 hover:text-green-600 group ${
                  location.pathname === item.path 
                    ? 'text-green-600' 
                    : 'text-gray-700'
                }`}
              >
                {item.name}
                <span className={`absolute -bottom-2 left-0 h-0.5 bg-gradient-to-r from-green-600 to-yellow-500 transition-all duration-300 ${
                  location.pathname === item.path ? 'w-full' : 'w-0 group-hover:w-full'
                }`}></span>
              </Link>
            ))}
          </nav>

          {/* Bouton d'appel Ultra-Moderne - DESKTOP SEULEMENT - JAMAIS SUR MOBILE */}
          {!isMobile && (
            <div className="hidden md:flex items-center space-x-4">
              <button
                onClick={handleCall}
                className="frelon-btn frelon-btn-primary frelon-glow flex items-center space-x-3 px-6 py-3 text-white font-bold rounded-2xl shadow-xl transform hover:scale-105 transition-all duration-300"
                data-testid="header-call-button"
                data-gtm-event="phone_click"
              >
                <Phone className="h-5 w-5" />
                <span className="tracking-wide">06 76 58 30 38</span>
              </button>
            </div>
          )}

          {/* Menu Mobile Button UNIQUEMENT - PAS DE BOUTON D'APPEL ICI */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-expanded={isMenuOpen}
              className="text-gray-700 hover:text-green-600 hover:bg-green-50 p-3 rounded-full transition-all duration-300 z-50 relative menu-toggle"
              data-testid="mobile-menu-toggle"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Menu Mobile Ultra-Moderne - SANS BOUTON D'APPEL */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full frelon-glass backdrop-blur-20 border border-white/20 rounded-b-3xl frelon-slide-up shadow-2xl">
            <nav className="flex flex-col space-y-2 px-6 py-6">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`font-medium py-4 px-4 rounded-2xl transition-all duration-300 ${
                    location.pathname === item.path 
                      ? 'text-green-600 bg-green-50/80' 
                      : 'text-gray-700 hover:bg-green-50/60 hover:text-green-600'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              
              {/* PAS de bouton d'appel ici - Uniquement en bas à droite */}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;